export const MAIN_TANK_INDEX = 9;

export default {
    MAIN_TANK_INDEX
}